import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatUrl',
    standalone: false
})
export class FormatUrlPipe implements PipeTransform {
    transform(link: string): string {
        if (link.indexOf('https') === -1 || link.indexOf('http') === -1) {
            link = 'https://' + link;
        }
        return link;
    }
}
